import { getDefaultValue } from "./form_utils";

export default function FormBuilder({ schema, values, onChange }) {
  const renderField = (field) => {
    const {
      name,
      type,
      options = [],
      itemType,
      schema: nestedSchema,
    } = field;
    const val = values[name];

    switch (type) {
      case "text":
        return (
          <label key={name}>
            {name}:
            <input
              type="text"
              value={val || ""}
              onChange={(e) => onChange(name, e.target.value)}
            />
          </label>
        );

      case "number":
        return (
          <label key={name}>
            {name}:
            <input
              type="number"
              value={val !== undefined ? val : ""}
              onChange={(e) =>
                onChange(
                  name,
                  e.target.value === "" ? "" : Number(e.target.value)
                )
              }
            />
          </label>
        );

      case "datetime":
        return (
          <label key={name}>
            {name}:
            <input
              type="datetime-local"
              value={val || ""}
              onChange={(e) => onChange(name, e.target.value)}
            />
          </label>
        );

      case "checkbox":
        return (
          <label key={name}>
            {name}
            <input
              type="checkbox"
              checked={!!val}
              onChange={(e) => onChange(name, e.target.checked)}
            />
          </label>
        );

      case "select":
        return (
          <label key={name}>
            {name}:
            <select
              value={val || options[0]}
              onChange={(e) => onChange(name, e.target.value)}
            >
              {options.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </label>
        );

      case "object":
        return (
          <fieldset key={name} className="form-builder__object">
            <legend>{name}</legend>
            <FormBuilder
              schema={nestedSchema}
              values={val || {}}
              onChange={(subName, subValue) =>
                onChange(name, { ...(val || {}), [subName]: subValue })
              }
            />
          </fieldset>
        );

      case "list":
        return (
          <div key={name} className="form-builder__list">
            <label>{name}:</label>
            {(val || []).map((item, idx) => (
              <div key={idx} className="form-builder__list-item">
                {itemType === "object" ? (
                  <FormBuilder
                    schema={nestedSchema}
                    values={item}
                    onChange={(subName, subValue) =>
                      onChange(
                        name,
                        val.map((it, i) =>
                          i === idx ? { ...it, [subName]: subValue } : it
                        )
                      )
                    }
                  />
                ) : (
                  <input
                    type={itemType === "number" ? "number" : "text"}
                    value={item}
                    onChange={(e) => {
                      const newVal =
                        itemType === "number"
                          ? e.target.value === ""
                            ? ""
                            : Number(e.target.value)
                          : e.target.value;
                      onChange(
                        name,
                        val.map((it, i) => (i === idx ? newVal : it))
                      );
                    }}
                  />
                )}
                <button
                  type="button"
                  onClick={() =>
                    onChange(
                      name,
                      val.filter((_, i) => i !== idx)
                    )
                  }
                >
                  Remove
                </button>
              </div>
            ))}
            <button
              type="button"
              onClick={() => {
                const newItem =
                  itemType === "object"
                    ? getDefaultValue({ type: "object", schema: nestedSchema })
                    : getDefaultValue({ type: itemType, options });
                onChange(name, [...(val || []), newItem]);
              }}
            >
              Add item
            </button>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="form-builder">
      {schema.fields.map(renderField)}
    </div>
  );
}
